// Fonctions pures de la liste des tâches.

// Nom affiché d'une tâche : celui du catalogue du produit (les identifiants
// peuvent être des nombres d'un côté et des chaînes de l'autre), sinon le nom
// porté par la tâche, sinon un libellé neutre.
export const nomDeTache = (catalogue, todo) => {
  const reference = (catalogue || []).find((tache) => String(tache.id) === String(todo.taskId));
  return (reference && reference.name) || todo.name || "Tâche";
};

// « 2 faites sur 7 », vide sans tâche.
export const resumeFaites = (todos) => {
  const total = (todos || []).length;
  if (!total) return "";
  const faites = todos.filter((todo) => todo.isDone).length;
  return `${faites} faite${faites > 1 ? "s" : ""} sur ${total}`;
};
